export default __webpack_public_path__ + "static/media/consultation.b9d3bc1a.svg";